export const enum imagesUrls{
    FEATURES = '/images/features/',
    HOME = '/images/home/',
    PRICING = '/images/pricing/',
    SHARED = '/images/shared/',
    STORIES = '/images/stories/',
}